import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  perSplitBannerOuter: {
    width: '100%',
  },
  perSplitBanner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
    width: '100%',
  },
  perSplitInfoIcon: {
    color: theme.palette.info.dark,
    fontSize: 20,
    flexShrink: 0,
  },
  messageRow: {
    flex: '1 1 0',
    minWidth: 0,
  },
  perSplitBannerMessage: {
    color: theme.palette.info.dark,
  },
  editSplitsInline: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    verticalAlign: 'middle',
  },
  editSplitsLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
    textUnderlineOffset: 2,
    border: 'none',
    background: 'none',
    padding: 0,
    fontSize: theme.typography.captionRegular.fontSize,
    fontFamily: theme.typography.captionRegular.fontFamily,
    fontWeight: theme.typography.captionRegular.fontWeight,
    lineHeight: theme.typography.captionRegular.lineHeight,
    letterSpacing: theme.typography.captionRegular.letterSpacing,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}));

type SplitExcludeFromMenuBannerProps = {
  editSplitsDisabled: boolean;
  onEditSplits: () => void;
};

/**
 * Info banner for the transaction actions menu when “Exclude from” is disabled for split transactions.
 * Matches the VisibilitySection per-split callout in Transaction Details.
 */
export const SplitExcludeFromMenuBanner = ({
  editSplitsDisabled,
  onEditSplits,
}: SplitExcludeFromMenuBannerProps): React.ReactElement => {
  const { classes, cx } = useStyles();

  return (
    <Box className={classes.perSplitBannerOuter}>
      <Box className={classes.perSplitBanner}>
        <InfoIcon className={classes.perSplitInfoIcon} aria-hidden />
        <Typography variant='captionRegular' component='div' className={classes.messageRow} sx={{ m: 0 }}>
          <Box component='span' className={classes.perSplitBannerMessage}>
            This setting is managed per split.{' '}
          </Box>
          {editSplitsDisabled ? (
            <Box component='span' className={classes.editSplitsInline} sx={{ color: 'text.disabled' }}>
              Edit Splits
              <ChevronRightIcon sx={{ fontSize: 16 }} aria-hidden />
            </Box>
          ) : (
            <Box
              component='button'
              type='button'
              className={cx(classes.editSplitsLink, classes.editSplitsInline)}
              onClick={(e) => {
                e.stopPropagation();
                onEditSplits();
              }}
              id='txn-menu-exclude-from-edit-splits'
            >
              Edit Splits
              <ChevronRightIcon sx={{ fontSize: 16, color: 'inherit' }} aria-hidden />
            </Box>
          )}
        </Typography>
      </Box>
    </Box>
  );
};
